import styled from 'styled-components'

export const Container = styled.div`
  padding: 25px 0;
`
export const Padding = styled.div`
  padding: 5px 0;
`
